/* src/app/umbrella-common/components/binary-question-with-comment/binary-question-with-comment.style.scss */
.wrapper {
  display: flex;
  flex-direction: column;
}
.flex-gap {
  display: flex;
  flex: 1 0 8px;
}
/*# sourceMappingURL=binary-question-with-comment.style.css.map */
